const getSiblings = (e) => {
	// for collecting siblings
	let siblings = [];

	// if no parent, return no sibling
	if (!e.parentNode) {
		return siblings;
	}

	// first child of the parent node
	let sibling = e.parentNode.firstChild;

	// collecting siblings
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== e) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

const removeAllChildNodes = (parent) => {
	while (parent.firstChild) {
		parent.removeChild(parent.firstChild);
	}
};

const getRandomInt = (max) => {
	return Math.floor(Math.random() * max);
};

const calculateVH = () => {
	const offset =
		window.innerWidth < 768 &&
		document.body.classList.contains("has-sticky-header")
			? document.querySelector("#wrapper-navbar").clientHeight
			: 0;
	const vh = (window.innerHeight - offset) * 0.01;

	Array.from(document.querySelectorAll(".vh")).forEach(function (el) {
		el.style.setProperty("--vh", vh + "px");
	});
};

module.exports = {
	getSiblings,
	removeAllChildNodes,
	getRandomInt,
	calculateVH,
};
